import React from 'react';
import { Upload, FileText, Calendar, Clock, CheckCircle2, ChevronDown, Wallet, DollarSign, TrendingUp, BarChart3, Building2, Info } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, AreaChart, Area, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
// Card Revenue Data (Monthly Revenue in Millions, Jan-22 to Mar-25)
const cardRevenueData = [{
  month: 'Jan-22',
  revenue: 3.2
}, {
  month: 'Feb-22',
  revenue: 3.3
}, {
  month: 'Mar-22',
  revenue: 3.4
}, {
  month: 'Apr-22',
  revenue: 3.3
}, {
  month: 'May-22',
  revenue: 3.5
}, {
  month: 'Jun-22',
  revenue: 3.5
}, {
  month: 'Jul-22',
  revenue: 3.6
}, {
  month: 'Aug-22',
  revenue: 3.6
}, {
  month: 'Sep-22',
  revenue: 3.7
}, {
  month: 'Oct-22',
  revenue: 3.7
}, {
  month: 'Nov-22',
  revenue: 3.8
}, {
  month: 'Dec-22',
  revenue: 3.8
}, {
  month: 'Jan-23',
  revenue: 3.5
}, {
  month: 'Feb-23',
  revenue: 3.6
}, {
  month: 'Mar-23',
  revenue: 3.7
}, {
  month: 'Apr-23',
  revenue: 3.6
}, {
  month: 'May-23',
  revenue: 3.7
}, {
  month: 'Jun-23',
  revenue: 3.8
}, {
  month: 'Jul-23',
  revenue: 3.9
}, {
  month: 'Aug-23',
  revenue: 3.8
}, {
  month: 'Sep-23',
  revenue: 4.0
}, {
  month: 'Oct-23',
  revenue: 4.0
}, {
  month: 'Nov-23',
  revenue: 4.1
}, {
  month: 'Dec-23',
  revenue: 4.1
}, {
  month: 'Jan-24',
  revenue: 3.8
}, {
  month: 'Feb-24',
  revenue: 3.8
}, {
  month: 'Mar-24',
  revenue: 4.0
}, {
  month: 'Apr-24',
  revenue: 3.9
}, {
  month: 'May-24',
  revenue: 4.0
}, {
  month: 'Jun-24',
  revenue: 4.1
}, {
  month: 'Jul-24',
  revenue: 4.2
}, {
  month: 'Aug-24',
  revenue: 4.1
}, {
  month: 'Sep-24',
  revenue: 4.3
}, {
  month: 'Oct-24',
  revenue: 4.3
}, {
  month: 'Nov-24',
  revenue: 4.4
}, {
  month: 'Dec-24',
  revenue: 4.4
}, {
  month: 'Jan-25',
  revenue: 4.1
}, {
  month: 'Feb-25',
  revenue: 4.2
}, {
  month: 'Mar-25',
  revenue: 4.3
}];
// Days Beyond Terms Data
const dbtData = [{
  month: 'Oct-24',
  dbt: 7,
  industry: 12,
  yourAR: 3
}, {
  month: 'Nov-24',
  dbt: 6,
  industry: 11,
  yourAR: 2
}, {
  month: 'Dec-24',
  dbt: 5,
  industry: 10,
  yourAR: 2
}, {
  month: 'Jan-25',
  dbt: 10,
  industry: 10,
  yourAR: 4
}, {
  month: 'Feb-25',
  dbt: 8,
  industry: 9,
  yourAR: 3
}, {
  month: 'Mar-25',
  dbt: 6,
  industry: 9,
  yourAR: 2
}, {
  month: 'Apr-25',
  dbt: 9,
  industry: 9,
  yourAR: 3
}, {
  month: 'May-25',
  dbt: 8,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jun-25',
  dbt: 7,
  industry: 9,
  yourAR: 2
}, {
  month: 'Jul-25',
  dbt: 7,
  industry: 9,
  yourAR: 3
}, {
  month: 'Aug-25',
  dbt: 11,
  industry: 10,
  yourAR: 4
}];
// Trade Payment Aging Data
const paidData = [{
  name: 'Current',
  value: 28500000
}, {
  name: '1-30',
  value: 1200000
}, {
  name: '31-60',
  value: 85000
}, {
  name: '61-90',
  value: 12000
}, {
  name: '91+',
  value: 3000
}];
const outstandingData = [{
  name: 'Current',
  value: 1650000
}, {
  name: '1-30',
  value: 180000
}, {
  name: '31-60',
  value: 15000
}, {
  name: '61-90',
  value: 5000
}, {
  name: '91+',
  value: 0
}];
// Trade Spend by Industry Data
const tradeSpendData = [{
  name: 'Paper & Pulp Manufacturing',
  value: 777000,
  color: '#4f46e5',
  percentage: 42
}, {
  name: 'Office Supplies & Equipment',
  value: 333000,
  color: '#10b981',
  percentage: 18
}, {
  name: 'Transportation & Logistics',
  value: 278000,
  color: '#8b5cf6',
  percentage: 15
}, {
  name: 'Printing Services',
  value: 185000,
  color: '#f59e0b',
  percentage: 10
}, {
  name: 'Administrative Services',
  value: 148000,
  color: '#ec4899',
  percentage: 8
}, {
  name: 'IT & Technology',
  value: 74000,
  color: '#06b6d4',
  percentage: 4
}, {
  name: 'Other',
  value: 56000,
  color: '#9ca3af',
  percentage: 3
}];
// Payment Aging by Industry Data
const paymentAgingData = [{
  industry: 'Paper & Pulp Manufacturing',
  total: '$777K',
  trades: 12,
  current: 92,
  days1to30: 6,
  days31to60: 2,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Office Supplies & Equipment',
  total: '$333K',
  trades: 35,
  current: 95,
  days1to30: 5,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Transportation & Logistics',
  total: '$278K',
  trades: 42,
  current: 88,
  days1to30: 8,
  days31to60: 3,
  days61to90: 1,
  days91plus: 0
}, {
  industry: 'Printing Services',
  total: '$185K',
  trades: 18,
  current: 90,
  days1to30: 7,
  days31to60: 3,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Administrative Services',
  total: '$148K',
  trades: 22,
  current: 94,
  days1to30: 6,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'IT & Technology',
  total: '$74K',
  trades: 8,
  current: 100,
  days1to30: 0,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}, {
  industry: 'Other',
  total: '$56K',
  trades: 5,
  current: 93,
  days1to30: 7,
  days31to60: 0,
  days61to90: 0,
  days91plus: 0
}];
export function FinancialsTab() {
  return <div className="space-y-8 mt-8" data-id="element-1164">
      {/* Financial Statement Analysis */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-1165">
        <div className="flex justify-between items-start mb-8" data-id="element-1166">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-1167">
            Financial Statement Analysis
          </h2>
          <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-5 py-2.5 rounded-lg flex items-center gap-2 font-medium text-sm transition-colors" data-id="element-1168">
            <Upload className="w-4 h-4" data-id="element-1169" />
            UPLOAD FINANCIAL STATEMENT
          </button>
        </div>

        {/* Financial Statement Box */}
        <div className="border border-gray-200 bg-gray-50 rounded-lg p-5 mb-8" data-id="element-1170">
          <p className="text-sm font-medium text-gray-500 mb-3 uppercase tracking-wider" data-id="element-1171">
            Latest Financial Statement
          </p>
          <div className="flex items-center justify-between bg-white p-4 rounded border border-gray-200 shadow-sm" data-id="element-1172">
            <div className="flex items-center gap-6" data-id="element-1173">
              <div className="flex items-center gap-3" data-id="element-1174">
                <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-1175">
                  <FileText className="w-5 h-5 text-indigo-600" data-id="element-1176" />
                </div>
                <span className="font-semibold text-gray-900 text-lg" data-id="element-1177">
                  DM-Financial-Statement-2025-Q1
                </span>
              </div>
              <div className="h-6 w-px bg-gray-300" data-id="element-1178"></div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-1179">
                <Calendar className="w-4 h-4" data-id="element-1180" />
                <span className="font-medium" data-id="element-1181">2025</span>
              </div>
              <div className="flex items-center gap-2 text-gray-600" data-id="element-1182">
                <Clock className="w-4 h-4" data-id="element-1183" />
                <span className="font-medium" data-id="element-1184">Q1</span>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-1185">
              <div className="flex items-center gap-1.5 bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-1186">
                <CheckCircle2 className="w-4 h-4 text-green-600" data-id="element-1187" />
                <span className="text-green-700 font-medium text-sm" data-id="element-1188">
                  Completed
                </span>
              </div>
              <button className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-1189">
                <ChevronDown className="w-5 h-5 text-gray-500" data-id="element-1190" />
              </button>
            </div>
          </div>
        </div>

        {/* Ratio Cards - All 5 in one row */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-1191">
          {/* Liquidity Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1192">
            <div className="flex items-center gap-2 mb-4" data-id="element-1193">
              <div className="w-8 h-8 bg-blue-50 rounded-lg flex items-center justify-center" data-id="element-1194">
                <Wallet className="w-4 h-4 text-blue-600" data-id="element-1195" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1196">Liquidity</h3>
            </div>
            <div className="space-y-3" data-id="element-1197">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1198">
                <span className="text-xs text-gray-600" data-id="element-1199">Current Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1200">2.85</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1201">
                <span className="text-xs text-gray-600" data-id="element-1202">Quick Ratio</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1203">2.41</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1204">
                <span className="text-xs text-gray-600" data-id="element-1205">Working Capital</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1206">$8.6M</span>
              </div>
            </div>
          </div>

          {/* Cash Flow Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1207">
            <div className="flex items-center gap-2 mb-4" data-id="element-1208">
              <div className="w-8 h-8 bg-green-50 rounded-lg flex items-center justify-center" data-id="element-1209">
                <DollarSign className="w-4 h-4 text-green-600" data-id="element-1210" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1211">Cash Flow</h3>
            </div>
            <div className="space-y-3" data-id="element-1212">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1213">
                <span className="text-xs text-gray-600" data-id="element-1214">Op. Cash Flow</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-1215">1.52</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1216">
                <span className="text-xs text-gray-600" data-id="element-1217">Free Cash Flow</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1218">$2.4M</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1219">
                <span className="text-xs text-gray-600" data-id="element-1220">CF Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1221">12.35</span>
              </div>
            </div>
          </div>

          {/* Profitability Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1222">
            <div className="flex items-center gap-2 mb-4" data-id="element-1223">
              <div className="w-8 h-8 bg-purple-50 rounded-lg flex items-center justify-center" data-id="element-1224">
                <TrendingUp className="w-4 h-4 text-purple-600" data-id="element-1225" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1226">Profitability</h3>
            </div>
            <div className="space-y-2" data-id="element-1227">
              <div className="flex justify-between items-center border-b border-gray-100 pb-1.5" data-id="element-1228">
                <span className="text-xs text-gray-600" data-id="element-1229">Net Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1230">0.08</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-1.5" data-id="element-1231">
                <span className="text-xs text-gray-600" data-id="element-1232">ROE</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1233">0.18</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-1.5" data-id="element-1234">
                <span className="text-xs text-gray-600" data-id="element-1235">Gross Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1236">0.32</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-1.5" data-id="element-1237">
                <span className="text-xs text-gray-600" data-id="element-1238">Op. Margin</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1239">0.12</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1240">
                <span className="text-xs text-gray-600" data-id="element-1241">ROA</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1242">0.09</span>
              </div>
            </div>
          </div>

          {/* Efficiency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1243">
            <div className="flex items-center gap-2 mb-4" data-id="element-1244">
              <div className="w-8 h-8 bg-orange-50 rounded-lg flex items-center justify-center" data-id="element-1245">
                <BarChart3 className="w-4 h-4 text-orange-600" data-id="element-1246" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1247">Efficiency</h3>
            </div>
            <div className="space-y-3" data-id="element-1248">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1249">
                <span className="text-xs text-gray-600" data-id="element-1250">Inv. Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1251">8.50</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1252">
                <span className="text-xs text-gray-600" data-id="element-1253">AR Turnover</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1254">10.20</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1255">
                <span className="text-xs text-gray-600" data-id="element-1256">DSO</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-1257">35.78</span>
              </div>
            </div>
          </div>

          {/* Solvency Ratios */}
          <div className="border border-gray-200 rounded-lg p-4 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-1258">
            <div className="flex items-center gap-2 mb-4" data-id="element-1259">
              <div className="w-8 h-8 bg-teal-50 rounded-lg flex items-center justify-center" data-id="element-1260">
                <Building2 className="w-4 h-4 text-teal-600" data-id="element-1261" />
              </div>
              <h3 className="text-sm font-bold text-gray-900" data-id="element-1262">Solvency</h3>
            </div>
            <div className="space-y-3" data-id="element-1263">
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1264">
                <span className="text-xs text-gray-600" data-id="element-1265">Debt-to-Equity</span>
                <span className="font-bold text-sm text-gray-900" data-id="element-1266">0.65</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-100 pb-2" data-id="element-1267">
                <span className="text-xs text-gray-600" data-id="element-1268">Z-Score</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1269">3.42</span>
              </div>
              <div className="flex justify-between items-center" data-id="element-1270">
                <span className="text-xs text-gray-600" data-id="element-1271">Int. Coverage</span>
                <span className="font-bold text-sm text-green-600" data-id="element-1272">18.50</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Card Revenue Metrics */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-1273">
        <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-1274">
          Card Revenue Metrics
        </h2>

        {/* Summary Stats - Flex layout for better spacing */}
        <div className="flex flex-wrap justify-between items-center gap-6 mb-10 bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-1275">
          <div className="flex flex-col" data-id="element-1276">
            <span className="text-3xl font-black text-gray-900 mb-1" data-id="element-1277">
              $5.1M
            </span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1278">
              Annual Card Revenue
            </span>
          </div>
          <div className="w-px h-12 bg-gray-200 hidden md:block" data-id="element-1279"></div>
          <div className="flex flex-col" data-id="element-1280">
            <span className="text-3xl font-black text-gray-900 mb-1" data-id="element-1281">6.8K</span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1282">
              Transactions
            </span>
          </div>
          <div className="w-px h-12 bg-gray-200 hidden md:block" data-id="element-1283"></div>
          <div className="flex flex-col" data-id="element-1284">
            <span className="text-3xl font-black text-gray-900 mb-1" data-id="element-1285">$750</span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1286">
              Avg Ticket Size
            </span>
          </div>
          <div className="w-px h-12 bg-gray-200 hidden md:block" data-id="element-1287"></div>
          <div className="flex flex-col" data-id="element-1288">
            <span className="text-3xl font-black text-gray-900 mb-1" data-id="element-1289">
              0 - 28
            </span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1290">
              Daily Transactions
            </span>
          </div>
          <div className="w-px h-12 bg-gray-200 hidden md:block" data-id="element-1291"></div>
          <div className="flex flex-col" data-id="element-1292">
            <span className="text-3xl font-black text-green-600 mb-1" data-id="element-1293">+6%</span>
            <span className="text-sm font-medium text-gray-500 uppercase tracking-wide" data-id="element-1294">
              YoY Growth
            </span>
          </div>
        </div>

        {/* Area Chart */}
        <div className="h-80 w-full" data-id="element-1295">
          <ResponsiveContainer width="100%" height="100%" data-id="element-1296">
            <AreaChart data={cardRevenueData} margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 0
          }} data-id="element-1297">
              <defs data-id="element-1298">
                <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1" data-id="element-1299">
                  <stop offset="5%" stopColor="#4f46e5" stopOpacity={0.3} data-id="element-1300" />
                  <stop offset="95%" stopColor="#4f46e5" stopOpacity={0} data-id="element-1301" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1302" />
              <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} interval={3} dy={10} data-id="element-1303" />
              <YAxis axisLine={true} tickLine={true} tick={{
              fontSize: 12,
              fill: '#6b7280'
            }} domain={[0, 8]} ticks={[0, 2, 4, 6, 8]} tickFormatter={value => `$${value}M`} data-id="element-1304" />
              <Tooltip formatter={(value: any) => `$${Number(value).toFixed(1)}M`} contentStyle={{
              borderRadius: '8px',
              border: '1px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              padding: '12px'
            }} data-id="element-1305" />
              <Area type="monotone" dataKey="revenue" stroke="#4f46e5" strokeWidth={3} fillOpacity={1} fill="url(#colorRevenue)" activeDot={{
              r: 6,
              fill: '#4f46e5',
              stroke: '#fff',
              strokeWidth: 2
            }} data-id="element-1306" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Trade Payment Information */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8" data-id="element-1307">
        {/* Trade Credit */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-1308">
          <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-1309">
            Trade Credit
          </h2>
          <div className="grid grid-cols-2 gap-x-8 gap-y-8" data-id="element-1310">
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1311">
              <span className="text-3xl font-bold text-gray-900 mb-1" data-id="element-1312">
                $50K
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1313">
                Recommended Credit Limit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1314">
              <span className="text-3xl font-bold text-gray-900 mb-1" data-id="element-1315">3</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1316">
                Days Beyond Terms
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1317">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1318">142</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1319">
                Trade Experiences
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1320">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1321">
                $1.85M
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1322">
                Total Trades Balance
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1323">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1324">
                $275K
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1325">
                Recent High Credit
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1326">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1327">
                $13.0K
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1328">
                Average Credit Amount
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1329">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1330">
                $12.5K
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1331">
                Past Due
              </span>
            </div>
            <div className="flex flex-col border-b border-gray-100 pb-4" data-id="element-1332">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1333">
                0.7%
              </span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1334">
                Past Due %
              </span>
            </div>
            <div className="flex flex-col" data-id="element-1335">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1336">$0</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1337">
                Severely Past Due
              </span>
            </div>
            <div className="flex flex-col" data-id="element-1338">
              <span className="text-2xl font-bold text-gray-900 mb-1" data-id="element-1339">0%</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1340">
                Severely Past Due %
              </span>
            </div>
          </div>
        </div>

        {/* Days Beyond Terms Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 flex flex-col lg:col-span-3" data-id="element-1341">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start mb-4 gap-4" data-id="element-1342">
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-1343">
              Days Beyond Terms
            </h2>
            <div className="flex flex-wrap items-center gap-4 text-sm bg-gray-50 px-4 py-2 rounded-lg border border-gray-100" data-id="element-1344">
              <div className="flex items-center gap-2" data-id="element-1345">
                <div className="w-6 h-0.5 border-t-2 border-dashed border-gray-400" data-id="element-1346"></div>
                <span className="font-medium text-gray-600" data-id="element-1347">Industry</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1348">
                <div className="w-6 h-0.5 bg-gray-900" data-id="element-1349"></div>
                <span className="font-medium text-gray-900" data-id="element-1350">DBT</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-1351">
                <div className="w-6 h-0.5 bg-indigo-600" data-id="element-1352"></div>
                <span className="font-medium text-indigo-600" data-id="element-1353">Your AR</span>
              </div>
            </div>
          </div>
          <p className="text-sm text-gray-500 mb-8 max-w-md leading-relaxed" data-id="element-1354">
            Compare how they pay the industry, how they pay their vendors
            generally, and how they pay you.
          </p>
          <div className="flex-1 min-h-[250px] w-full mt-auto" data-id="element-1355">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1356">
              <LineChart data={dbtData} margin={{
              top: 5,
              right: 10,
              left: -20,
              bottom: 0
            }} data-id="element-1357">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1358" />
                <XAxis dataKey="month" axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} dy={10} data-id="element-1359" />
                <YAxis axisLine={true} tickLine={true} tick={{
                fontSize: 12,
                fill: '#6b7280'
              }} domain={[0, 15]} ticks={[0, 5, 10, 15]} data-id="element-1360" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                padding: '12px'
              }} data-id="element-1361" />
                <Line type="monotone" dataKey="industry" name="Industry" stroke="#9ca3af" strokeWidth={2} strokeDasharray="5 5" dot={false} activeDot={{
                r: 6,
                fill: '#9ca3af'
              }} data-id="element-1362" />
                <Line type="monotone" dataKey="dbt" name="DBT" stroke="#111827" strokeWidth={2} dot={false} activeDot={{
                r: 6,
                fill: '#111827'
              }} data-id="element-1363" />
                <Line type="monotone" dataKey="yourAR" name="Your AR" stroke="#4f46e5" strokeWidth={3} dot={false} activeDot={{
                r: 6,
                fill: '#4f46e5'
              }} data-id="element-1364" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>

      {/* Trade Payment Aging */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-1365">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-8 gap-4" data-id="element-1366">
          <div data-id="element-1367">
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-1368">
              Trade Payment Information
            </h2>
            <div className="flex items-center gap-3 text-sm" data-id="element-1369">
              <span className="font-medium text-gray-900 bg-gray-100 px-2.5 py-1 rounded-md" data-id="element-1370">
                Total Trade Lines: 142
              </span>
              <span className="text-gray-500" data-id="element-1371">
                Updated Monthly - Next Update 04/01/2026
              </span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto mb-10 border border-gray-200 rounded-xl" data-id="element-1372">
          <table className="w-full text-left border-collapse" data-id="element-1373">
            <thead data-id="element-1374">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-1375">
                <th className="px-6 py-4 text-sm font-bold text-gray-900" data-id="element-1376">
                  Status
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1377">
                  Current
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1378">
                  1-30
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1379">
                  31-60
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1380">
                  61-90
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right" data-id="element-1381">
                  91+
                </th>
                <th className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-100" data-id="element-1382">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-1383">
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1384">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1385">
                  Paid
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1386">
                  $28,500,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1387">
                  $1,200,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1388">
                  $85,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1389">
                  $12,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1390">
                  $3,000
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1391">
                  $29,800,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1392">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1393">
                  Outstanding
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1394">
                  $1,650,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1395">
                  $180,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1396">
                  $15,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1397">
                  $5,000
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1398">
                  $0
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1399">
                  $1,850,000
                </td>
              </tr>
              <tr className="hover:bg-gray-50/50 transition-colors" data-id="element-1400">
                <td className="px-6 py-4 text-sm font-medium text-gray-900" data-id="element-1401">
                  Payment Experiences
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1402">
                  112
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1403">
                  22
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1404">
                  5
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1405">
                  2
                </td>
                <td className="px-6 py-4 text-sm text-gray-600 text-right" data-id="element-1406">
                  1
                </td>
                <td className="px-6 py-4 text-sm font-bold text-gray-900 text-right bg-gray-50" data-id="element-1407">
                  142
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Bar Charts */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1408">
          {/* Paid Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1409">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-1410">
              <div className="w-2 h-6 bg-green-600 rounded-full" data-id="element-1411"></div>
              Paid History
            </h3>
            <div className="h-64 w-full" data-id="element-1412">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1413">
                <BarChart data={paidData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-1414">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1415" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-1416" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-1417" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(1)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-1418" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-1420" />;
                }} data-id="element-1419" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* Outstanding Chart */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-1421">
            <h3 className="text-lg font-bold text-gray-900 mb-6 flex items-center gap-2" data-id="element-1422">
              <div className="w-2 h-6 bg-blue-600 rounded-full" data-id="element-1423"></div>
              Outstanding Balance
            </h3>
            <div className="h-64 w-full" data-id="element-1424">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1425">
                <BarChart data={outstandingData} margin={{
                top: 5,
                right: 10,
                left: 0,
                bottom: 0
              }} data-id="element-1426">
                  <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" data-id="element-1427" />
                  <XAxis dataKey="name" axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} dy={10} data-id="element-1428" />
                  <YAxis axisLine={true} tickLine={true} tick={{
                  fontSize: 12,
                  fill: '#6b7280'
                }} tickFormatter={value => `$${value / 1000000}M`} data-id="element-1429" />
                  <Tooltip formatter={(value: any) => `$${(value / 1000000).toFixed(2)}M`} contentStyle={{
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                  padding: '12px'
                }} cursor={{
                  fill: '#e5e7eb',
                  opacity: 0.4
                }} data-id="element-1430" />
                  <Bar dataKey="value" radius={[4, 4, 0, 0]} shape={(props: any) => {
                  const {
                    x,
                    y,
                    width,
                    height,
                    name
                  } = props;
                  let fill = '#16a34a';
                  if (name === '31-60') fill = '#84cc16';
                  if (name === '61-90') fill = '#f59e0b';
                  if (name === '91+') fill = '#dc2626';
                  return <rect x={x} y={y} width={width} height={height} fill={fill} rx={4} ry={4} data-id="element-1432" />;
                }} data-id="element-1431" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </div>

      {/* Trade Spend by Industry Section */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1433">
        {/* Trade Spend Donut Chart */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-1" data-id="element-1434">
          <h2 className="text-xl font-bold text-gray-900 mb-6" data-id="element-1435">
            Trade Spend by Industry
          </h2>
          <div className="relative h-64 w-full mb-8" data-id="element-1436">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1437">
              <PieChart data-id="element-1438">
                <Pie data={tradeSpendData} cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={2} dataKey="value" stroke="none" data-id="element-1439">
                  {tradeSpendData.map((entry, index) => <Cell key={`cell-${index}`} fill={entry.color} data-id="element-1440" />)}
                </Pie>
                <Tooltip formatter={(value: any) => `$${(value / 1000).toFixed(0)}K`} contentStyle={{
                borderRadius: '8px',
                border: '1px solid #e5e7eb',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
              }} data-id="element-1441" />
              </PieChart>
            </ResponsiveContainer>
            <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none" data-id="element-1442">
              <span className="text-2xl font-black text-gray-900" data-id="element-1443">$1.85M</span>
              <span className="text-sm font-medium text-gray-500" data-id="element-1444">
                Total Spend
              </span>
            </div>
          </div>

          {/* Custom Legend */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3" data-id="element-1445">
            {tradeSpendData.map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-1446">
                <div className="w-3 h-3 rounded-full" style={{
              backgroundColor: item.color
            }} data-id="element-1447"></div>
                <span className="text-sm text-gray-600" data-id="element-1448">
                  {item.name} {item.percentage}%
                </span>
              </div>)}
          </div>
        </div>

        {/* Payment Aging by Industry */}
        <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-8 lg:col-span-2" data-id="element-1449">
          <div className="flex justify-between items-center mb-8" data-id="element-1450">
            <h2 className="text-xl font-bold text-gray-900" data-id="element-1451">
              Payment Aging by Industry
            </h2>
            <div className="flex bg-gray-100 rounded-lg p-1" data-id="element-1452">
              <button className="px-3 py-1 text-sm font-medium bg-white shadow-sm rounded-md text-gray-900" data-id="element-1453">
                %
              </button>
              <button className="px-3 py-1 text-sm font-medium text-gray-500 hover:text-gray-900" data-id="element-1454">
                $
              </button>
            </div>
          </div>

          <div className="space-y-6" data-id="element-1455">
            {paymentAgingData.map((item, index) => <div key={index} className="flex flex-col gap-2" data-id="element-1456">
                <div className="flex justify-between items-end" data-id="element-1457">
                  <span className="text-sm font-medium text-gray-700" data-id="element-1458">
                    {item.industry}
                  </span>
                  <span className="text-sm text-gray-500" data-id="element-1459">
                    {item.total} ({item.trades})
                  </span>
                </div>
                {/* Stacked Bar */}
                <div className="h-6 w-full flex rounded-sm overflow-hidden" data-id="element-1460">
                  {item.current > 0 && <div style={{
                width: `${item.current}%`
              }} className="bg-[#16a34a] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1461">
                      {item.current > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1462">
                          {item.current}%
                        </span>}
                    </div>}
                  {item.days1to30 > 0 && <div style={{
                width: `${item.days1to30}%`
              }} className="bg-[#84cc16] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1463">
                      {item.days1to30 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1464">
                          {item.days1to30}%
                        </span>}
                    </div>}
                  {item.days31to60 > 0 && <div style={{
                width: `${item.days31to60}%`
              }} className="bg-[#facc15] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1465">
                      {item.days31to60 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1466">
                          {item.days31to60}%
                        </span>}
                    </div>}
                  {item.days61to90 > 0 && <div style={{
                width: `${item.days61to90}%`
              }} className="bg-[#f59e0b] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1467">
                      {item.days61to90 > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1468">
                          {item.days61to90}%
                        </span>}
                    </div>}
                  {item.days91plus > 0 && <div style={{
                width: `${item.days91plus}%`
              }} className="bg-[#dc2626] h-full flex items-center justify-center border-r border-white/20 last:border-0" data-id="element-1469">
                      {item.days91plus > 10 && <span className="text-[10px] font-bold text-white" data-id="element-1470">
                          {item.days91plus}%
                        </span>}
                    </div>}
                </div>
              </div>)}
          </div>

          <div className="mt-8 text-center border-t border-gray-100 pt-4" data-id="element-1471">
            <button className="text-indigo-600 text-sm font-medium hover:text-indigo-700 uppercase tracking-wider" data-id="element-1472">
              Show More
            </button>
          </div>
        </div>
      </div>
    </div>;
}